'use client'

import { CHECK_FOR_COOKIE_KEY, LOGIN_PATH } from '@lib/constants'
import { Spinner } from 'react-bootstrap'
import { api } from 'src/trpc/react'
import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

export const ClientSideAuthChecker: React.FC = () => {
  const query = useSearchParams()
  const path = usePathname()

  const { data, error } = api.shared.user.profile.useQuery(undefined, {
    retry: false,
    meta: { errorKeysToIgnore: ['UNAUTHORIZED'] },
  })

  useEffect(() => {
    if (data) {
      const filteredQuery = new URLSearchParams(query)
      filteredQuery.delete(CHECK_FOR_COOKIE_KEY)
      const newSearchParameters = filteredQuery.toString()
      const redirectUrl = newSearchParameters
        ? `${path}?${newSearchParameters}`
        : path
      if (redirectUrl) {
        window.location.href = redirectUrl
      }
    }

    if (error && path !== LOGIN_PATH) {
      // Include current path and query parameters as redirect parameter
      const currentUrl = `${path}${query.toString() ? `?${query.toString()}` : ''}`
      const loginUrl = `${LOGIN_PATH}?redirect=${encodeURIComponent(currentUrl)}`
      window.location.href = loginUrl
    }
  }, [data, error, path, query])

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Spinner />
    </div>
  )
}
